<template>
  <div class="ggtf-my-participation dark-theme">
    <div class="ggtf-empty-state" v-if="videoList.length === 0 && !loading">
      <div class="ggtf-empty-icon">📹</div>
      <h3>{{ $t('_wdtg._wjl') }}</h3>
    </div>

    <div v-else>
      <div v-for="video in videoList" :key="video.id" class="ggtf-my-video-card">
        <!-- 封面图 -->
        <div class="ggtf-my-video-cover">
          <img :src="video.img" :alt="video.title" class="ggtf-cover-image" />
          <div class="ggtf-cover-status" v-if="video.status === 3">
            <span class="status-badge completed">{{ $t('_wdtg._jxz') }}</span>
          </div>
          <div class="ggtf-cover-status" v-if="video.status === 1">
            <span class="status-badge pending">{{ $t('_wdtg._qzf') }}</span>
          </div>
        </div>

        <!-- 信息区 -->
        <div class="ggtf-my-video-info-wrapper">
          <div class="ggtf-my-video-info">
            <h4 class="ggtf-my-video-title">{{ video.title }}</h4>
            <div class="ggtf-my-activity-code">
              <span class="code-label">{{ $t('_ggtf._hdbm') }}:</span>
              <span class="code-value">{{ video.code }}</span>
            </div>

            <!-- 统计数据 -->
            <div class="ggtf-my-stats">
              <div class="ggtf-my-stat">
                <span class="ggtf-stat-label">{{ $t('_wdtg._tzje') }}</span>
                <span class="ggtf-stat-value">${{ video.amount }}</span>
              </div>
              <div class="ggtf-my-stat">
                <span class="ggtf-stat-label">{{ $t('_wdtg._zsy') }}</span>
                <span class="ggtf-stat-value ggtf-profit">+${{ video.income }}</span>
              </div>
              <div class="ggtf-my-stat">
                <span class="ggtf-stat-label">{{ $t('_wdtg._hdts') }}</span>
                <span class="ggtf-stat-value">{{ video.days }}</span>
              </div>
              <div class="ggtf-my-stat">
                <span class="ggtf-stat-label">{{ $t('_wdtg._cysj') }}</span>
                <span class="ggtf-stat-value">{{ formatDate(video.create_time) }}</span>
              </div>
            </div>

            <!-- 支付提醒 -->
            <div class="ggtf-status dks2" v-if="video.status === 1">
              <div class="sdgqe">
                <div class="sdktiqjr">{{ $t('_wdtg._qzf') }}</div>
              </div>
              <div class="sferr">{{ $t('_bq._zfjz') }}</div>
              <div class="ssdgt">{{ $t('_bq.jz') }}: {{ video.last_pay }}</div>
            </div>
          </div>

          <!-- 支付按钮 -->
          <div class="bbst1" v-if="video.status === 1">
            <button class="ggtf-buy-btn" @click="onPay(video)">{{ $t('_bq._qzf') }}</button>
          </div>

          <!-- 收益明细 -->
          <div class="aart">
            <!-- 昨日待结算 -->
            <div class="set1 sdttq1 wjsb" v-if="video.zr_income_status == 3">
              <div class="dq13t">
                <span>[{{ video.zr_date }}]</span>
                <span>({{ $t('_wdtg._djs') }})</span>
              </div>
              <div class="sbox">
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._zrsy') }}</span>
                  <div class="skke">
                    <span class="sk1 wjsys">$</span>
                    <span class="sydde wjsys">{{ video.zr_income }}</span>
                  </div>
                </div>
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._dbl') }}</span>
                  <div class="skke">
                    <span class="sk1">$</span>
                    <span class="sykge">{{ video.zr_buy_num }}</span>
                  </div>
                </div>
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._bfl') }}</span>
                  <div class="skke">
                    <span class="sykge">{{ video.zr_play_num }}</span>
                  </div>
                </div>
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._wdsy') }}</span>
                  <div class="skke">
                    <span class="sk1">$</span>
                    <span class="sykge">{{ video.zr_real_income }}</span>
                  </div>
                </div>
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._bqffc') }}</span>
                  <div class="skke">
                    <span class="sk1">$</span>
                    <span class="sykge">{{ video.zr_store_income }}</span>
                  </div>
                </div>
              </div>
              <div class="sqrcbox">
                <button class="qzfann" :class="{ than24: video.zr_expired_hours < 24 }" @click="onTransfer(video)">
                  {{ $t('_ggtg._qhz') }}
                </button>
              </div>
            </div>

            <!-- 收益结算 -->
            <div class="set1 sdttq1" v-if="video.status == 3 && video.jt_income_status > 0 && video.zr_income_status != 3">
              <div class="dq13t">
                <span>({{ $t('_wdtg._mr0djs') }})</span>
              </div>
              <div class="sbox">
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._jrsy') }}</span>
                  <div class="skke">
                    <span class="sk1">$</span>
                    <span class="sydde">{{ video.jt_income }}</span>
                  </div>
                </div>
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._dbl') }}</span>
                  <div class="skke">
                    <span class="sk1">$</span>
                    <span class="sykge">{{ video.jt_buy_num }}</span>
                  </div>
                </div>
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._bfl') }}</span>
                  <div class="skke">
                    <span class="sykge">{{ video.jt_play_num }}</span>
                  </div>
                </div>
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._wdsy') }}</span>
                  <div class="skke">
                    <span class="sk1">$</span>
                    <span class="sykge">{{ video.jt_real_income }}</span>
                  </div>
                </div>
                <div class="syde">
                  <span class="sywz">{{ $t('_wdtg._bqffc') }}</span>
                  <div class="skke">
                    <span class="sk1">$</span>
                    <span class="sykge">{{ video.jt_store_income }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="ggtf-load-more">
      <button class="ggtf-load-more-btn" @click="loadMore" v-if="hasMore">
        <span v-if="loading">{{ $t('_a._jzz') }}</span>
        <span v-else>{{ $t('_a._jzgd') }}</span>
      </button>
      <div class="ggtf-no-more" v-else>{{ $t('_wdtg._mygd') }}</div>
    </div>

    <adv-buy ref="buy" @success="onSuccess"></adv-buy>
    <AdvTransfer ref="transfer" @success="onTransferSuccess"></AdvTransfer>
  </div>
</template>

<script>
import AdvBuy from '@/components/adv/AdvBuy.vue'
import AdvTransfer from '@/components/adv/AdvTransfer.vue'
export default {
  components: { AdvBuy, AdvTransfer },
  data() {
    return {
      loading: false,
      hasMore: true,
      page: 1,
      size: 4,
      videoList: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    onPay(item) {
      this.$refs.buy.open(item, item.code)
    },
    onSuccess() {
      this.getList(1)
    },
    onTransfer(item) {
      this.$refs.transfer.open(item)
    },
    onTransferSuccess() {
      this.getList(1)
    },
    loadMore() {
      this.getList()
    },
    getList(page = 0) {
      let that = this
      if (page > 0) {
        this.videoList = []
        this.page = page
        this.isMore = true
      }
      if (this.loading) return
      this.loading = true

      this.$api.videoAdv
        .getMyAdvList({
          page: that.page,
          size: that.size
        })
        .then((res) => {
          that.loading = false
          that.page++
          if (res.data.length == 0) {
            that.hasMore = false
            return
          }
          res.data.forEach((item) => {
            that.videoList.push(item)
          })
          that.hasMore = res.data.length >= that.size
        })
    },
    formatDate(date) {
      return (
        new Date(date).toLocaleDateString('zh-CN') +
        ' ' +
        new Date(date).toLocaleTimeString('zh-CN', {
          hour: '2-digit',
          minute: '2-digit'
        })
      )
    }
  }
}
</script>

<style scoped>
/* ===== 深色主题 ===== */
.dark-theme {
  background: #0b0d0f;
  min-height: 100vh;
  padding: 20px 0;
}

/* ===== 卡片 ===== */
.ggtf-my-video-card {
  display: flex;
  gap: 24px;
  background: #1a1f26;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #2a3038;
  transition: all 0.3s ease;
}

.ggtf-my-video-card:hover {
  border-color: #ffb300;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

/* ===== 封面 ===== */
.ggtf-my-video-cover {
  flex: 0 0 200px;
  /* height: 120px; */
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  background: #0a0d0f;
}

.ggtf-cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ggtf-cover-status {
  position: absolute;
  top: 8px;
  right: 8px;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.status-badge.pending {
  background: rgba(255, 179, 0, 0.2);
  color: #ffb300;
  border: 1px solid rgba(255, 179, 0, 0.3);
}

.status-badge.completed {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

/* ===== 信息区 ===== */
.ggtf-my-video-info-wrapper {
  flex: 1;
  position: relative;
}

.ggtf-my-video-title {
  color: #e8edf2;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.ggtf-my-activity-code {
  color: #8a949f;
  font-size: 14px;
  margin-bottom: 12px;
}

.code-label {
  color: #6a7a8a;
}

.code-value {
  color: #b0bcc8;
  font-weight: 500;
}

/* ===== 统计 ===== */
.ggtf-my-stats {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.ggtf-my-stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ggtf-stat-label {
  font-size: 12px;
  color: #6a7a8a;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ggtf-stat-value {
  color: #e8edf2;
  font-size: 18px;
  font-weight: 700;
}

.ggtf-profit {
  color: #4caf50;
}

/* ===== 支付按钮 ===== */
.bbst1 {
  position: absolute;
  right: 0;
  top: 0;
}

.ggtf-buy-btn {
  padding: 10px 28px;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  border: none;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ggtf-buy-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(255, 179, 0, 0.3);
}

/* ===== 状态提醒 ===== */
.ggtf-status {
  margin-top: 12px;
}

.sdgqe .sdktiqjr {
  background: rgba(255, 179, 0, 0.15);
  color: #ffb300;
  font-size: 14px;
  border: 1px dashed rgba(255, 179, 0, 0.3);
  padding: 6px 14px;
  border-radius: 8px;
  display: inline-block;
}

.sferr {
  color: #ff6b6b;
  font-size: 14px;
}

.ssdgt {
  color: #6a7a8a;
  font-size: 14px;
}

/* ===== 收益明细 ===== */
.aart {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  flex-wrap: wrap;
}

.set1 {
  background: #0a0d0f;
  border-radius: 12px;
  padding: 16px 20px;
  border: 1px solid #2a3038;
  flex: 1;
  min-width: 280px;
}

.sdttq1 {
  border-color: #2a3038;
}

.wjsb {
  border-color: rgba(255, 107, 107, 0.3);
}

.dq13t {
  color: #8a949f;
  font-size: 14px;
  margin-bottom: 12px;
}

.dq13t span:first-child {
  color: #e8edf2;
  font-weight: 600;
}

.sbox {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.syde {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sywz {
  font-size: 12px;
  color: #6a7a8a;
}

.skke {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.sk1 {
  font-size: 13px;
  color: #8a949f;
}

.sydde {
  color: #4caf50;
  font-size: 20px;
  font-weight: 700;
}

.sykge {
  color: #4caf50;
  font-size: 17px;
  font-weight: 600;
}

.wjsys {
  color: #ff6b6b;
}

.sqrcbox {
  display: flex;
  justify-content: center;
  margin-top: 12px;
}

.qzfann {
  padding: 8px 32px;
  background: #2a3038;
  color: #b0bcc8;
  border: none;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.qzfann:hover {
  background: #3a4652;
  color: #e8edf2;
}

.than24 {
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
}

.than24:hover {
  box-shadow: 0 4px 20px rgba(255, 179, 0, 0.3);
}

/* ===== 空状态 ===== */
.ggtf-empty-state {
  text-align: center;
  padding: 80px 20px;
  background: #1a1f26;
  border-radius: 16px;
  border: 1px solid #2a3038;
}

.ggtf-empty-icon {
  font-size: 64px;
  margin-bottom: 20px;
}

.ggtf-empty-state h3 {
  color: #e8edf2;
  font-size: 24px;
  margin: 0 0 8px 0;
}

/* ===== 加载更多 ===== */
.ggtf-load-more {
  text-align: center;
  padding: 20px 0;
}

.ggtf-load-more-btn {
  padding: 12px 40px;
  background: #1a1f26;
  color: #b0bcc8;
  border: 1px solid #2a3038;
  border-radius: 30px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ggtf-load-more-btn:hover {
  background: #2a3038;
  color: #e8edf2;
  border-color: #ffb300;
}

.ggtf-no-more {
  color: #4a5662;
  font-size: 14px;
}

/* ===== 隐藏滚动条 ===== */
.dark-theme {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.dark-theme::-webkit-scrollbar,
.dark-theme *::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .ggtf-my-video-card {
    flex-direction: column;
    padding: 16px;
  }

  .ggtf-my-video-cover {
    flex: 0 0 auto;
    height: 180px;
    width: 100%;
  }

  .bbst1 {
    position: static;
    margin-top: 12px;
  }

  .ggtf-buy-btn {
    width: 100%;
  }

  .ggtf-my-stats {
    gap: 16px;
  }

  .sbox {
    gap: 16px;
  }

  .aart {
    flex-direction: column;
  }

  .set1 {
    min-width: unset;
  }
}

@media (max-width: 480px) {
  .ggtf-my-stat-value {
    font-size: 16px;
  }

  .ggtf-my-video-title {
    font-size: 16px;
  }

  .ggtf-my-video-cover {
    height: 140px;
  }
}
</style>